// extracted by mini-css-extract-plugin
module.exports = {"grid":"ShowcaseGrid_grid__e1fhW","grid-carousel":"ShowcaseGrid_grid-carousel__jOcjh","container":"ShowcaseGrid_container__WFWUB","scroll-area":"ShowcaseGrid_scroll-area__HR83f"};